var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBosch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 106,
    viewBox: "0 0 87 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8112 71.2979C35.7124 74.3866 35.0425 74.994 35.8312 79.2176C36.6199 83.4413 39.292 93.9547 37.8112 97.0371C36.3304 100.12 24.9461 100.059 22.9616 97.0371C20.9771 94.0152 24.7448 83.3938 25.9315 79.2176C26.7794 76.234 22.9616 71.2979 22.9616 71.2979H37.8112Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.52 53.4784C66.52 53.4784 71.9649 56.4483 73.9448 48.9867C74.9348 44.5687 73.9448 39.681 73.9448 39.681L58.6003 40.6088L56.6203 43.5787L66.52 53.4784Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.841 73.2778C52.8836 73.2778 67.51 65.5214 67.51 55.9533C67.51 46.3853 52.8836 38.6289 34.841 38.6289C16.7984 38.6289 2.172 46.3853 2.172 55.9533C2.172 65.5214 16.7984 73.2778 34.841 73.2778Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4764 69.3179C32.1379 69.3179 40.7808 63.3344 40.7808 55.9533C40.7808 48.5723 32.1379 42.5888 21.4764 42.5888C10.8149 42.5888 2.172 48.5723 2.172 55.9533C2.172 63.3344 10.8149 69.3179 21.4764 69.3179Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5802 41.5988C74.2488 41.5988 85.3294 38.053 85.3294 33.679C85.3294 29.3051 74.2488 25.7593 60.5802 25.7593C46.9116 25.7593 35.831 29.3051 35.831 33.679C35.831 38.053 46.9116 41.5988 60.5802 41.5988Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6705 7.93982C52.9834 5.95988 55.5632 3.22067 58.6003 3.97994C60.5802 4.47492 61.9002 6.45486 61.0752 8.92979C60.0853 11.8997 56.6203 13.8796 53.6502 17.8395C51.1755 21.3044 49.7913 25.7593 52.6605 29.7192C56.2264 34.6406 65.5301 34.669 68.9949 29.7192C72.4598 24.7693 70.4799 16.8495 69.49 12.8897C68.5 8.92979 65.0351 2 59.5903 2C55.6304 2 53.1555 5.46489 51.6705 7.93982Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6805 11.8997C52.3207 11.8997 53.6504 10.57 53.6504 8.92979C53.6504 7.28956 52.3207 5.95988 50.6805 5.95988C49.0403 5.95988 47.7106 7.28956 47.7106 8.92979C47.7106 10.57 49.0403 11.8997 50.6805 11.8997Z",
    fill: "#909090"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.095 53.9734C61.5699 55.9534 69.9139 62.3882 68.4997 72.2879C67.0147 82.6825 67.1682 93.0338 68.4997 98.0271C70.2881 104.734 57.6103 104.462 54.6403 103.472C49.8515 101.876 49.6681 96.3488 54.1452 85.1575C56.1254 80.2076 58.9663 76.3566 58.105 73.2778C57.2437 70.199 53.1551 68.823 51.6702 63.3781",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.095 53.9734C61.5699 55.9534 69.9139 62.3882 68.4997 72.2879C67.0147 82.6825 67.1682 93.0338 68.4997 98.0271C70.2881 104.734 57.6103 104.462 54.6403 103.472C49.8515 101.876 49.6681 96.3488 54.1452 85.1575C56.1254 80.2076 58.9663 76.3566 58.105 73.2778C57.2437 70.199 53.1551 68.823 51.6702 63.3781",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3178 21.2422C45.8664 21.6537 46.6446 21.2293 46.5957 20.5452L46.2863 16.213C46.2534 15.7531 45.8396 15.4161 45.3826 15.477L40.741 16.0959C40.0309 16.1906 39.7936 17.0991 40.3667 17.5289L45.3178 21.2422Z",
    fill: "#909090"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7407 16.8496L50.6805 8.92979",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosch);
export default __webpack_public_path__ + "static/media/Bosch.092ed341.svg";
export { ForwardRef as ReactComponent };var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBosch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 106,
    viewBox: "0 0 87 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8112 71.2979C35.7124 74.3866 35.0425 74.994 35.8312 79.2176C36.6199 83.4413 39.292 93.9547 37.8112 97.0371C36.3304 100.12 24.9461 100.059 22.9616 97.0371C20.9771 94.0152 24.7448 83.3938 25.9315 79.2176C26.7794 76.234 22.9616 71.2979 22.9616 71.2979H37.8112Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.52 53.4784C66.52 53.4784 71.9649 56.4483 73.9448 48.9867C74.9348 44.5687 73.9448 39.681 73.9448 39.681L58.6003 40.6088L56.6203 43.5787L66.52 53.4784Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.841 73.2778C52.8836 73.2778 67.51 65.5214 67.51 55.9533C67.51 46.3853 52.8836 38.6289 34.841 38.6289C16.7984 38.6289 2.172 46.3853 2.172 55.9533C2.172 65.5214 16.7984 73.2778 34.841 73.2778Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4764 69.3179C32.1379 69.3179 40.7808 63.3344 40.7808 55.9533C40.7808 48.5723 32.1379 42.5888 21.4764 42.5888C10.8149 42.5888 2.172 48.5723 2.172 55.9533C2.172 63.3344 10.8149 69.3179 21.4764 69.3179Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5802 41.5988C74.2488 41.5988 85.3294 38.053 85.3294 33.679C85.3294 29.3051 74.2488 25.7593 60.5802 25.7593C46.9116 25.7593 35.831 29.3051 35.831 33.679C35.831 38.053 46.9116 41.5988 60.5802 41.5988Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6705 7.93982C52.9834 5.95988 55.5632 3.22067 58.6003 3.97994C60.5802 4.47492 61.9002 6.45486 61.0752 8.92979C60.0853 11.8997 56.6203 13.8796 53.6502 17.8395C51.1755 21.3044 49.7913 25.7593 52.6605 29.7192C56.2264 34.6406 65.5301 34.669 68.9949 29.7192C72.4598 24.7693 70.4799 16.8495 69.49 12.8897C68.5 8.92979 65.0351 2 59.5903 2C55.6304 2 53.1555 5.46489 51.6705 7.93982Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6805 11.8997C52.3207 11.8997 53.6504 10.57 53.6504 8.92979C53.6504 7.28956 52.3207 5.95988 50.6805 5.95988C49.0403 5.95988 47.7106 7.28956 47.7106 8.92979C47.7106 10.57 49.0403 11.8997 50.6805 11.8997Z",
    fill: "#909090"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.095 53.9734C61.5699 55.9534 69.9139 62.3882 68.4997 72.2879C67.0147 82.6825 67.1682 93.0338 68.4997 98.0271C70.2881 104.734 57.6103 104.462 54.6403 103.472C49.8515 101.876 49.6681 96.3488 54.1452 85.1575C56.1254 80.2076 58.9663 76.3566 58.105 73.2778C57.2437 70.199 53.1551 68.823 51.6702 63.3781",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.095 53.9734C61.5699 55.9534 69.9139 62.3882 68.4997 72.2879C67.0147 82.6825 67.1682 93.0338 68.4997 98.0271C70.2881 104.734 57.6103 104.462 54.6403 103.472C49.8515 101.876 49.6681 96.3488 54.1452 85.1575C56.1254 80.2076 58.9663 76.3566 58.105 73.2778C57.2437 70.199 53.1551 68.823 51.6702 63.3781",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3178 21.2422C45.8664 21.6537 46.6446 21.2293 46.5957 20.5452L46.2863 16.213C46.2534 15.7531 45.8396 15.4161 45.3826 15.477L40.741 16.0959C40.0309 16.1906 39.7936 17.0991 40.3667 17.5289L45.3178 21.2422Z",
    fill: "#909090"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7407 16.8496L50.6805 8.92979",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosch);
export default __webpack_public_path__ + "static/media/Bosch.092ed341.svg";
export { ForwardRef as ReactComponent };